import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const TITLE_LINE_HEIGHT = 1.35;
const INDICATOR_PADDING_VERTICAL = "1px";
const TITLE_MARGIN = `1px 0 ${designTokens.spacing[1]}`;

export const useVaultMeetingChipStyles = makeStyles({
  chip: {
    listStyleType: "none",
    margin: 0,
    minWidth: 0,
    overflow: "hidden",
    boxSizing: "border-box",
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[2]}`,
    backgroundColor: projectIqTokens.tealSoft,
    border: "1px solid transparent",
    borderRadius: designTokens.borderRadius.md,
  },
  chipSaved: {
    border: `1px solid ${projectIqTokens.teal}`,
  },
  time: {
    margin: 0,
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.muted,
  },
  title: {
    margin: TITLE_MARGIN,
    fontSize: designTokens.fontSize["2xs"],
    fontWeight: designTokens.fontWeight.semibold,
    lineHeight: TITLE_LINE_HEIGHT,
    color: projectIqTokens.ink,
    overflowWrap: "anywhere",
  },
  indicators: {
    display: "flex",
    flexWrap: "wrap",
    gap: designTokens.spacing[1],
    margin: 0,
    padding: 0,
    listStyleType: "none",
  },
  indicator: {
    padding: `${INDICATOR_PADDING_VERTICAL} ${designTokens.spacing[2]}`,
    borderRadius: designTokens.borderRadius.full,
    fontSize: designTokens.fontSize.xxs,
    fontWeight: designTokens.fontWeight.semibold,
    whiteSpace: "nowrap",
    border: "1px solid transparent",
  },
  indicatorTranscript: {
    backgroundColor: projectIqTokens.card,
    color: projectIqTokens.tealInk,
    border: `1px solid ${projectIqTokens.tealLine}`,
  },
  indicatorNoTranscript: {
    backgroundColor: "transparent",
    color: projectIqTokens.muted,
    border: `1px solid ${projectIqTokens.line}`,
  },
  indicatorSaved: {
    backgroundColor: projectIqTokens.teal,
    color: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.teal}`,
  },
});
